export const venueSettingsModals = {
  TIP_CONFIGURATIONS: 'tipConfigurations',
}
